import { useCallback } from "react";

import { useClubsFiltersAdressesStore } from "@/stores/clubs-filters-store";

export const useAdressesFromGouv = () => {
  const setAdresses = useClubsFiltersAdressesStore(
    (state) => state.setAdresses,
  );

  const fetchAdresses = useCallback(
    async (
      value: string,
      latitude?: number,
      longitude?: number,
      isGeolocation: boolean = false,
    ) => {
      try {
        // Éviter les requêtes pour des termes trop courts
        if (typeof value === "string" && value.length < 3 && !isGeolocation) {
          setAdresses([]);
          return null;
        }

        const url = new URL(
          isGeolocation
            ? "https://data.geopf.fr/geocodage/reverse"
            : "https://data.geopf.fr/geocodage/search",
        );
        const params = new URLSearchParams();

        if (isGeolocation) {
          params.set("lat", latitude?.toString() || "");
          params.set("lon", longitude?.toString() || "");
        } else {
          params.set("q", value);
          params.set("limit", "5"); // Limiter à 5 résultats
        }

        const response = await fetch(`${url}?${params.toString()}`);
        const data = await response.json();

        if (!response.ok) {
          throw new Error(`Erreur API: ${response.status}`);
        }

        const features = data.features || [];
        setAdresses(features);

        // Retourner la première adresse si c'est une géolocalisation
        if (isGeolocation && features.length > 0) {
          const firstAddress = features[0];
          return {
            address:
              firstAddress.properties.label || firstAddress.properties.name,
            zipCode: firstAddress.properties.postcode,
            city: firstAddress.properties.city,
            latitude: firstAddress.geometry.coordinates[1],
            longitude: firstAddress.geometry.coordinates[0],
          };
        }

        return null;
      } catch (err) {
        console.error("Erreur lors de la récupération des adresses:", err);
        setAdresses([]);
        return null;
      }
    },
    [setAdresses],
  );

  return { fetchAdresses };
};
